import type { ElementType, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
    as?: ElementType
}

// Shared page gutter and maximum width for every section.
export const Container: FC<ContainerProps> = ({ children, className, as: Tag = 'div' }): ReactNode => {
    return (
        <Tag className={cn('mx-auto w-full max-w-[1440px] px-5 sm:px-8 lg:px-12', className)}>
            {children}
        </Tag>
    )
}
